/* eslint-disable react/no-array-index-key */
import React from 'react';
import { fromJS } from 'immutable';
import { Field } from 'formik';
import c from 'classnames';

import {
  WysiwygField,
} from '..';

import './style.scss';

const Radio = (props) => {
  return (
    <Field name={props.name} validate={props.validate}>
      {({ field, form }) => {
        const name = `${props.name}--${props.value}`;
        const classes = c('WebformRadios__radio__input', {
          'icon-before': true,
          'icon-radio': true,
          'icon-variant-1': field.value && field.value.includes(props.value),
          disabled: props.disabled,
        });

        if (props.value === '__other__') {
          const inputClasses = c({
            hidden: (field.value !== '__other__'),
          });

          return (
            <div className={classes}>
              <input
                {...field}
                type="radio"
                id={name}
                value={props.value}
              />
              <label htmlFor={name}>
                {props.otherLabel}
              </label>
              <textarea
                placeholder={props.otherPlaceholder}
                className={inputClasses}
                onChange={(e) => {
                  form.setFieldValue(`${props.name}--other`, e.target.value);
                }}
              />
            </div>
          );
        }

        return (
          <label htmlFor={name} className={classes}>
            <input
              {...field}
              type="radio"
              id={name}
              value={props.value}
            />
            {props.label}
          </label>
        );
      }}
    </Field>
  );
};

function Checkbox(props) {
  const { name, value, label, validate } = props;
  return (
    <Field name={name} validate={validate}>
      {({ field, form }) => {
        const nameLower = `${name}--${value}`;
        const classes = c('WebformCheckboxes__checkbox__input', {
          'icon-before': true,
          'icon-checkmark': true,
          'icon-variant-1': field.value && field.value.includes(value),
          disabled: props.disabled,
        });

        return (
          <label htmlFor={nameLower} className={classes}>
            <input
              {...field}
              type="checkbox"
              id={nameLower}
              checked={field.value && field.value.includes(value)}
              onChange={() => {
                const set = new Set(field.value);
                if (set.has(value)) {
                  set.delete(value);
                } else {
                  set.add(value);
                }
                form.setFieldValue(field.name, Array.from(set));
                form.setFieldTouched(field.name, true);
              }}
            />
            {label}
          </label>
        );
      }}
    </Field>
  );
}

class WebformSignup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
    };
  }

  toggleRadioBtn(index, entity, webformKey, value) {
    value[webformKey] = index;
    this.setState({
      /* eslint react/no-unused-state: 0 react/no-access-state-in-setstate: 0*/
      selectedIndex: index,
      /* eslint react/no-unused-state: 0 react/no-access-state-in-setstate: 0*/
      selectedValue: this.state.options[index],
      options: this.state.options,
    });
  }

  render() {
    const { showOther, ...fieldProps } = this.props;
    const title = fieldProps.entity.get('#title');
    const required = fieldProps.entity.get('#required');
    const description = fieldProps.entity.get('#description');
    const requiredError = fieldProps.entity.get('#required_error');
    const webformKey = fieldProps.entity.get('#webform_key');
    const otherLabel = fieldProps.entity.get('#other__option_label');
    const otherPlaceholder = fieldProps.entity.get('#other__placeholder');
    const multiple = fieldProps.entity.get('#multiple', false);

    let options = fromJS(fieldProps.entity.get('#options'));

    if (showOther) {
      options = options.set('__other__', 'Anders');
    }

    function validation(value) {
      let error;
      if (required && !value) {
        error = requiredError || 'Dit is een vereist veld';
      }
      return error;
    }

    const allOptions = options.entrySeq().map(([key, entity]) => {
      let label;
      let availability = 0;
      let disabled = false;
      let labelText;

      [label, availability] = entity.split(' -- ');

      const reservations = fieldProps.entity.getIn(['#reservations', key], 0);
      if (parseInt(reservations) >= parseInt(availability)) {
        disabled = true;
        labelText = `${label} (niet meer beschikbaar)`;
      }
      else {
        labelText = `${label} (${Math.max(availability - reservations)} van ${availability} beschikbaar)`;
      }

      if (multiple) {
        return (
          <Checkbox
            key={key}
            name={webformKey}
            value={key}
            label={labelText}
            validate={validation}
            disabled={disabled}
          />
        );
      }
      else {
        return (
          <Radio
            key={key}
            name={webformKey}
            value={key}
            label={labelText}
            validate={validation}
            otherLabel={otherLabel}
            otherPlaceholder={otherPlaceholder}
            disabled={disabled}
          />
        );
      }
    });

    let baseClass = 'WebformRadios';
    if (multiple) {
      baseClass = 'WebformCheckboxes';
    }

    return (
      <div className={baseClass}>
        <label htmlFor={webformKey}>{title}</label>
        <div>{allOptions}</div>
        { description && (
          <div className="row">
            <WysiwygField
              property="schema:text"
              html={description}
              className="col-12 WebformRadio__description WebformComponent--description" />
          </div>
        )}
        { fieldProps.errors[webformKey] && fieldProps.touched[webformKey] ? <div className="WebformRadio_error WebformComponent--error">{fieldProps.errors[webformKey]}</div> : null}
      </div>
    );
  }
}

export default WebformSignup;
